const tagsMap = {
  GENERAL: {
    name: '通项',
    color: '#0064FF',
    bgColor: '#E3EEFF',
  },
  PROJECT: {
    name: '项目',
    color: '#0064FF',
    bgColor: '#E3EEFF',
  },
  ADD: {
    name: '增项',
    color: '#EB3723',
    bgColor: '#FFEAE8',
  },
  SUB: {
    name: '减项',
    color: '#575859',
    bgColor: '#EDEFF2',
  },
  ACTIVITY: {
    name: '活动',
    color: '#00A865',
    bgColor: '#D7F7EA',
  },
  UP_DOWN: {
    name: '升降级',
    color: '#F25A0A',
    bgColor: '#FFEBE0',
  },
  NOTSTANDARD: {
    name: '非标配',
    color: '#70A310',
    bgColor: '#EAF5D5',
  },
  STANDARD: {
    name: '标配',
    color: '#0990D9',
    bgColor: '#D9F2FF',
  },
  PROCATENAME: {
    name: '产品类型',
    color: '#0064FF',
    bgColor: '#E3EEFF',
  },
  NATIONAL_UPPLEMENT: {
    name: '国补',
    color: '#00A865',
    bgColor: '#D7F7EA',
  },
  BUDGETTYPE: {
    name: '报价类型',
    color: '#0064FF',
    bgColor: '#E3EEFF',
  },
  GROUP: {
    name: '组合',
    color: '#F59300',
    bgColor: '#FFF0D9',
  },
  DISABLE: {
    name: '失效',
    color: '#EB3723',
    bgColor: '#FFEAE8',
  },
}
export default tagsMap
